let opts;
if (process.env.PLATFORM === 'alumnier') {
  opts = require('./data-alumnier');
} else if (process.env.PLATFORM === 'iceverg') {
  opts = require('./data-iceverg');
} else if (process.env.PLATFORM === '1cvrg') {
  opts = require('./data-bo');
} else if (process.env.PLATFORM === 'happyjob') {
  opts = require('./data-happyjob');
}

import Vue from 'vue';

const state = {
  sidebarOptions: opts.sidebarOptions,
  sidebarActive: false,
};

const getters = {
  sidebarOptions: state => {
    return state.sidebarOptions;
  },
  sidebarActive: state => {
    return state.sidebarActive;
  }
};

const actions = {
  setActiveMenuGroup(context, payload) {
      context.commit('setActiveMenuGroupHandler', payload);
  },
  toggleSidebar(context, payload) {
    context.commit('toggleSidebarHandler', payload);
  },
};

const mutations = {
  setActiveMenuGroupHandler(state, router) {
    let fullPath = '';
    if(router.pathURL){
      fullPath = router.pathURL;
    }else{
      fullPath = router.history.current.fullPath;
    }

    let section = fullPath.split('/')[1];
    for(let i = 0; i < state.sidebarOptions.length; i++) {
      //Vue.set(state.sidebarOptions[i], 'active', section === state.sidebarOptions[i].section);
      if (state.sidebarOptions[i].items) {
        state.sidebarOptions[i].items.forEach((item,k ) => {
          Vue.set(state.sidebarOptions[i].items[k], 'active', fullPath === item.path);
        })
      }
    }
  },
  toggleSidebarHandler(state, value) {
    state.sidebarActive = value;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sidebar/index.js